export const api: string = process.env.REACT_APP_API_QUOTEMAKER || "http://localhost:8080"
export const frontOfficeRootUri: string = process.env.REACT_APP_FRONT_OFFICE_ROOT_URI || "http://localhost:3010"
export const uploadApiUri: string = process.env.REACT_APP_UPLOAD_API || "http://localhost:8085"